// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f75b4a74","977":"4a9bf82d"}[chunkId] + ".chunk.js";
};